(function () {
  if (window.__cartInvoiceInit) return;
  window.__cartInvoiceInit = true;

  function debounce(fn, wait) {
    var timeout;

    return function () {
      var args = arguments;
      var context = this;

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function getState(wrapper) {
    var inputs = Array.from(wrapper.querySelectorAll('[data-cart-invoice-input]'));

    return {
      checkbox: wrapper.querySelector('.js-cart-invoice-toggle'),
      inputs: inputs,
      fields: wrapper.querySelector('[data-cart-invoice-fields]'),
      error: wrapper.querySelector('[data-cart-invoice-error]'),
      details: wrapper.querySelector('.cart-invoice__details'),
    };
  }

  function clearError(wrapper) {
    var state = getState(wrapper);

    wrapper.classList.remove('has-error');

    state.inputs.forEach(function (input) {
      input.classList.remove('is-invalid');
    });

    if (state.error) {
      state.error.textContent = '';
    }
  }

  function syncVisibility(wrapper) {
    var state = getState(wrapper);
    var enabled = !!(state.checkbox && state.checkbox.checked);

    if (state.fields) {
      state.fields.classList.toggle('is-visible', enabled);
    }

    if (state.details) {
      state.details.open = enabled;
    }

    state.inputs.forEach(function (input) {
      input.required = enabled;
      input.disabled = !enabled;

      if (!enabled && input.value !== '') {
        input.value = '';
      }
    });

    if (!enabled) {
      clearError(wrapper);
    }
  }

  function getPayloadValues(wrapper) {
    var state = getState(wrapper);
    var enabled = !!(state.checkbox && state.checkbox.checked);
    var fields = {};

    state.inputs.forEach(function (input) {
      fields[input.dataset.attributeKey] = enabled ? input.value.trim() : '';
    });

    return {
      enabled: enabled,
      fields: fields,
    };
  }

  function syncAllWrappers(values) {
    document.querySelectorAll('[data-cart-invoice]').forEach(function (wrapper) {
      var state = getState(wrapper);

      if (state.checkbox) {
        state.checkbox.checked = values.enabled;
      }

      state.inputs.forEach(function (input) {
        var nextValue = values.fields[input.dataset.attributeKey] || '';

        if (input.value !== nextValue) {
          input.value = nextValue;
        }
      });

      syncVisibility(wrapper);
    });
  }

  var saveAttributes = debounce(function (wrapper) {
    if (typeof fetchConfig !== 'function' || typeof routes === 'undefined') return;

    var values = getPayloadValues(wrapper);
    var payload = { attributes: {} };

    payload.attributes[wrapper.dataset.attributeInvoice] = values.enabled
      ? wrapper.dataset.attributeValueYes || 'Tak'
      : wrapper.dataset.attributeValueNo || 'Nie';

    Object.keys(values.fields).forEach(function (key) {
      payload.attributes[key] = values.fields[key];
    });

    fetch(routes.cart_update_url, {
      ...fetchConfig(),
      body: JSON.stringify(payload),
    }).catch(function (error) {
      console.error('Cart invoice attributes update failed', error);
    });
  }, 300);

  function validate(wrapper) {
    var state = getState(wrapper);
    var values = getPayloadValues(wrapper);
    var invalidInput;

    if (!values.enabled) {
      clearError(wrapper);
      return true;
    }

    invalidInput = state.inputs.find(function (input) {
      return input.value.trim() === '';
    });

    if (!invalidInput) {
      clearError(wrapper);
      return true;
    }

    wrapper.classList.add('has-error');

    state.inputs.forEach(function (input) {
      input.classList.toggle('is-invalid', input === invalidInput);
    });

    if (state.error) {
      state.error.textContent = wrapper.dataset.errorRequired || 'Complete invoice fields.';
    }

    invalidInput.focus();
    return false;
  }

  function findWrapperForSubmitter(submitter) {
    if (!submitter) return null;

    var formId = submitter.getAttribute('form');
    var form = formId ? document.getElementById(formId) : submitter.closest('form');

    return form ? form.querySelector('[data-cart-invoice]') : null;
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('button[name="checkout"], input[name="checkout"]');

      if (!button) return;

      var wrapper = findWrapperForSubmitter(button);

      if (wrapper && !validate(wrapper)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      var submitter = event.submitter;

      if (!form || !submitter || submitter.name !== 'checkout') return;

      var wrapper = form.querySelector('[data-cart-invoice]');

      if (wrapper && !validate(wrapper)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      if (!event.target.classList.contains('js-cart-invoice-toggle')) return;

      var wrapper = event.target.closest('[data-cart-invoice]');
      var values;

      if (!wrapper) return;

      values = getPayloadValues(wrapper);
      syncAllWrappers(values);
      saveAttributes(wrapper);
    },
    true
  );

  document.addEventListener(
    'input',
    function (event) {
      if (!event.target.classList.contains('js-cart-invoice-input')) return;

      var wrapper = event.target.closest('[data-cart-invoice]');
      var values;

      if (!wrapper) return;

      values = getPayloadValues(wrapper);
      syncAllWrappers(values);

      if (!stateHasMissingRequiredValue(wrapper)) {
        clearError(wrapper);
      } else {
        event.target.classList.remove('is-invalid');
      }

      saveAttributes(wrapper);
    },
    true
  );

  function stateHasMissingRequiredValue(wrapper) {
    return getState(wrapper).inputs.some(function (input) {
      return !input.disabled && input.value.trim() === '';
    });
  }

  function initAll() {
    document.querySelectorAll('[data-cart-invoice]').forEach(function (wrapper) {
      syncVisibility(wrapper);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
